import { SET, FETCH, FETCH_SUCCESS, SET_USER,SET_ALERT } from './actionTypes';
import IState from '../../models/state.model';
import IAction from '../../models/action.model';


const defaultStore: IState = {
  username: '',
  isAuthenticated: false,
  user: {},
  // alert: {
  //   open:false,
  //   severity:'success',
  //   alertMessage:'Mensaje exitoso'
  // }
}

export default function user(
  state: IState = defaultStore,
  action: any,
) {
  switch (action.type) {
    case 'SET_IS_AUTHENTICATED':
      return {
        ...state,
        isAuthenticated: action.payload
      };
    case SET:
      return {
        ...state,
        username: action.payload
      };

    case FETCH:
      return {
        ...state
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        username: action.payload
      }

    case SET_USER:
      return {
        ...state,
        user: action.payload
      }

    case SET_ALERT:
      return {
        ...state,
        alert: action.payload
      }

    default:
      return state;
  }
}
